var closeDropdown = function closeDropdown(wrapperRef, setShowDropdown) {
  var handleDropdown = function handleDropdown(showDropDown) {
    var hideDropDownOnScroll = function hideDropDownOnScroll() {
      setShowDropdown(false);
    };
    var hideDropDownOnClickOutside = function hideDropDownOnClickOutside(event) {
      if (showDropDown && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    window.addEventListener('scroll', hideDropDownOnScroll);
    document.addEventListener('click', hideDropDownOnClickOutside);
    var unsubscribe = function unsubscribe() {
      window.removeEventListener('scroll', hideDropDownOnScroll);
      document.removeEventListener('click', hideDropDownOnClickOutside);
    };
    if (!showDropDown) {
      return unsubscribe();
    }
    return function () {
      unsubscribe();
    };
  };
  return {
    handleDropdown: handleDropdown
  };
};
export default closeDropdown;